import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // メールアドレスを全角から半角への変換
  convert() {
    const inputString = this.element.value
    const fullWidthCharacters = '＠－ー＋＿．，、';
    const halfWidthCharacters = '@--+_...';
    let convertedString = '';

    for (let i = 0; i < inputString.length; i++) {
      const dataChar = inputString.charAt(i);
      const dataNum = fullWidthCharacters.indexOf(dataChar, 0);
      if (dataNum >= 0) {
        convertedString += halfWidthCharacters.charAt(dataNum);
      } else {
        convertedString += dataChar;
      }
    }

    const hankaku = convertedString.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });

    this.element.value = hankaku;
  }
}
